(function(){
  const U='https://form.jotform.com/212155385141045';
  const L='Randevu Al';

  function makeAppointmentLink(button){
    if(!button || button.dataset.whAppointmentReady==='true') return;

    const a=document.createElement('a');
    a.href=U;
    a.target='_self';
    a.rel='nofollow';
    a.className=(button.className||'')+' wh-appointment-button';
    a.setAttribute('aria-label',L);
    a.textContent=L;

    for(const attr of Array.from(button.attributes)){
      if(attr.name!=='class' && attr.name!=='id' && attr.name!=='type' && attr.name!=='name' && attr.name!=='disabled'){
        try{a.setAttribute(attr.name,attr.value)}catch(e){}
      }
    }

    button.replaceWith(a);
  }

  function hideCartLinks(root){
    const s=root||document;
    s.querySelectorAll('a[href*="/cart"]').forEach(function(a){
      if(a.id==='cart-icon-bubble'||a.classList.contains('header__icon--cart')) a.style.display='none';
    });
  }

  function init(root){
    const s=root||document;
    s.querySelectorAll('.product-form__submit,.quick-add__submit,button[name="add"],button[type="submit"][name="add"]').forEach(makeAppointmentLink);
    hideCartLinks(s);
  }

  function start(){
    init(document);
    if(!document.body) return;
    new MutationObserver(function(ms){
      ms.forEach(function(m){
        m.addedNodes.forEach(function(n){
          if(n.nodeType===1) init(n);
        });
      });
    }).observe(document.body,{childList:true,subtree:true});
  }

  document.readyState==='loading'
    ? document.addEventListener('DOMContentLoaded',start)
    : start();
})();